import { render, staticRenderFns } from "./SharedProducts.template.vue?vue&type=template&id=3b046a2d&scoped=true&"
var script = {}
import style0 from "./SharedProducts.template.vue?vue&type=style&index=0&id=3b046a2d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b046a2d",
  null
  
)

export default component.exports